import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import * as Yup from 'yup';
import { requiredFiles } from '../../useValidateQuestionnaire';
import {
  InterestStateValues,
  TForeignieNonUsInterestIncome,
  TForeignieNonUsInterestIncomeRow,
  updateFieldArrayKey,
  updateKey,
} from './slice';

// predicate:
// 'Displayed in case the user selected "Yes" to the Interest question in the General Subtab in the Income tab.',

export const fields: IBaseField<
  keyof InterestStateValues | keyof TForeignieNonUsInterestIncomeRow
>[] = [
  {
    name: 'didReceiveAnyInterestIncomeDuringTheFilingYear',
    label: 'Did receive any interest income during the filing year?',
    subLabel: () => <p>Refers to spouse, as well</p>,
    type: 'select',
    options: [
      {
        label: 'Yes - US Interest Only',
        value: 'Yes - US Interest Only',
      },
      {
        label: 'Yes - Foreign Interest Only',
        value: 'Yes - Foreign Interest Only',
      },
      {
        label: 'Both - US & Foreign Interest',
        value: 'Both - US & Foreign Interest',
      },
      {
        label: 'No',
        value: 'No',
      },
    ],
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        dependenciesTitle: 'U.S. Interest Income',
        name: 'usInterestIncome',
        label: 'US Interest Income',
        subLabel: () => (
          <p>Please upload form 1099-INT\nNot required if below $10</p>
        ),
        type: 'upload',
        predicate: (value) =>
          value === 'Yes - US Interest Only' ||
          value === 'Both - US & Foreign Interest',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        dependenciesTitle: 'Foreign (i.e Non-US) Interest Income',
        name: 'foreignieNonUsInterestIncome',
        label: 'Foreign (ie Non-US) Interest Income',
        type: 'fieldArray',
        predicate: (value) =>
          value === 'Yes - Foreign Interest Only' ||
          value === 'Both - US & Foreign Interest',
        tooltip: '',
        comment: true,
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        defaultDependency: {
          nameOfPayer: null,
          grossInterest: null,
          taxWithheld: null,
        },
        dependencies: [
          {
            name: 'nameOfPayer',
            label: 'Name of Payer',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter',
          },
          {
            name: 'grossInterest',
            label: 'Gross Interest',
            type: 'currency',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },

          {
            name: 'taxWithheld',
            label: 'Tax Withheld',
            type: 'currency',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
